import React from "react";
import "./About.css";

function About() {
  return (
    <div className="aboutContainer">
      <p className="bio">
        My name is Kirubel Eshetu Tefera. I am a Junior tech professional based
        in Addis Ababa, Ethiopia. I recently graduated with a bachelor's degree
        in computer science from Jimma University. After completion of my
        studies, I am committed to continuously expand my knowledge and skills
        in software development. With a strong work ethic and dedication, I am looking
        forward to contribute meaningfully and build a successful career in
        technology.
      </p>
    </div>
  );
}

export default About;
